import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchPublicPlaylists, type PublicPlaylist } from '../utils/api';
import { useI18n } from '../i18n/useI18n';

interface Props {
  prefetch?: PublicPlaylist[];
}

export default function LandingSinglists({ prefetch }: Props) {
  const { t } = useI18n();
  const [singlists, setSinglists] = useState<PublicPlaylist[]>(prefetch || []);
  const [loading, setLoading] = useState(!prefetch || prefetch.length === 0);

  useEffect(() => {
    if (prefetch && prefetch.length > 0) return;
    let cancelled = false;
    fetchPublicPlaylists(4)
      .then((data) => {
        if (cancelled) return;
        setSinglists(data);
      })
      .catch(() => {
        setSinglists([]);
      })
      .finally(() => setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [prefetch]);

  if (loading && singlists.length === 0) return null;
  if (singlists.length === 0) return null;

  return (
    <div className="landing-singlists">
      <div className="landing-singlists__header">
        <h2 className="landing-section-title">{t('landing.singlists.title')}</h2>
        <Link to="/join-room" className="landing-singlists__view-all">
          {t('landing.singlists.viewAll')}
        </Link>
      </div>
      <p className="landing-singlists__lead">{t('landing.singlists.description')}</p>
      <div className="landing-singlists__grid">
        {singlists.map((list) => (
          <Link key={list.id} to="/join-room" className="landing-singlist-card">
            <div className="landing-singlist-card__icon" aria-hidden="true">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 18V5l12-2v13" />
                <circle cx="6" cy="18" r="3" />
                <circle cx="18" cy="16" r="3" />
              </svg>
            </div>
            <div className="landing-singlist-card__body">
              <h3 className="landing-singlist-card__name">{list.name}</h3>
              <p className="landing-singlist-card__count">
                {list.item_count ?? 0} songs
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
